import { useCohort } from '@/components/user-context/helpers/cohorts';

import { LoggedInJiraNewUser } from '../components/logged-in-jira-new-user';

import { CurrentProductJoinableUser } from './current-product-joinable-user';
import { CurrentProductUser } from './current-product-user';
import { LoggedInJiraFreeExistingSitesUser } from './existing-sites-user';

export const LoggedInJiraFree = () => {
	const cohort = useCohort(true);

	if (cohort === 'current-product-user') {
		return <CurrentProductUser />;
	}

	if (cohort === 'current-product-joinable-user') {
		return <CurrentProductJoinableUser />;
	}

	if (cohort === 'new-user') {
		return <LoggedInJiraNewUser />;
	}

	if (cohort) {
		return <LoggedInJiraFreeExistingSitesUser />;
	}

	return null;
};
